import React from "react"
import { IDocumentReceivedReportParams } from "types"


interface Hook {
  params: IDocumentReceivedReportParams
  handleChangeParams: (key: string, value: any) => void
}

const useReceivedReportParams = (): Hook => {
  const [params, setParams] = React.useState<IDocumentReceivedReportParams>({
    simple: {
      documentEnd: new Date(),
      documentStart: new Date(),
    },

    accounting: {
      documentEnd: new Date(),
      documentStart: new Date(),
    },
  })
  const handleChangeParams = (key: string, value: any) => {
    setParams((current) => ({
      ...current,
      [key]: value,
    }))
  }
  return {
    params,
    handleChangeParams,
  }
}

export default useReceivedReportParams
